/**
 * Translates a given key using a set of translations.
 *
 * @param {string} key - The translation key in the format "namespace.key".
 * @param {string} [defaultValue] - The default value to return if the translation is not found.
 * @param {Array} replaceValues - Replaceable values for Template translation.
 * @param {Translations} [translations={}] - An object containing translation data organized by namespaces.
 * @returns {string} - The translated string or the default value if not found.
 *
 */
export const i18n = (key, defaultValue, replaceValues, translations = {}) => {
    var _a;
    const [namespace, tKey] = key.split('.');
    if ((_a = translations[namespace]) === null || _a === void 0 ? void 0 : _a[tKey]) {
        let translation = translations[namespace][tKey];
        // Replace Template Values.
        while (translation.indexOf('%s') !== -1) {
            translation = translation.replace('%s', replaceValues.shift());
        }
        return translation;
    }
    if (defaultValue) {
        while (defaultValue.indexOf('%s') !== -1) {
            defaultValue = defaultValue.replace('%s', replaceValues.shift());
        }
        return defaultValue;
    }
    return key;
};
//# sourceMappingURL=i18n.js.map